import axiosInstance from "../../utils/axios";
import Cookies from "js-cookie";

const ApiUser = Cookies.get("apiUser");
const apiUserObject = ApiUser ? JSON.parse(ApiUser) : null;

const projects = {
  state: {
    projects: [],
  },
  mutations: {
    setProjects(state, projects) {
      state.projects = projects;
    },
  },
  actions: {
    async fetchProjects({ commit }) {
      try {
        const response = await axiosInstance.get("/projects", {
          params: {
            page: "all",
            per_page: "all",
            involved_projects_by_employee: apiUserObject["employee"]["id"],
          },
        });
        commit("setProjects", response.data["projects"]);
      } catch (error) {
        console.log("Error en el Fecth de datos");
      }
    },
    async transitionProjectState(_, { projectId, payload }) {
      try {
        const response = await axiosInstance.post(
          `/projects/${projectId}/aasm_transition`,
          {
            ...payload,
          }
        );
        return response
      } catch (error) {
        console.log("Error en el Fecth de datos");
      }
    },
  },
  getters: {
    projectsCount(state) {
      return state.projects.length;
    },
  },
};

export default projects;
